
import "/app/src/components/Layout/SiderResizeHandle.less?modules";
export default {"dragMask": `dragMask-Xztg1YZ0`,"dragging": `dragging-tpCOj-lB`,"hitBox": `hitBox-4L2dvzb9`,"line": `line-DjUjOr6J`}
